export default "__VITE_ASSET__BBqVcLwg__"